import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';

export abstract class AbstractEnrollmentExtendedService {
  abstract updateDashboardStateId(
    dashboardStateId: string
  ): Promise<IApiResponse | void>;
  abstract updateBusinessProfileStateId(
    businessProfileStateId: string,
    dashboardStateId: string
  ): Promise<IApiResponse | void>;
  abstract updateFinancialProfileStateId(
    financialProfileStateId: string,
    dashboardStateId: string
  ): Promise<IApiResponse | void>;
  abstract updateCustomerPortfolioStateId(
    customerPortfolioStateId: string,
    dashboardStateId: string
  ): Promise<IApiResponse | void>;
  abstract createEnrollmentExtended(): Promise<IApiResponse>;
  abstract getEnrollmentExtended(): Promise<IApiResponse>;
  abstract activateBusinessProfile(): Promise<IApiResponse>;
  abstract completeBusinessProfile(): Promise<IApiResponse>;
  abstract activateFinancialProfile(): Promise<IApiResponse>;
  abstract completeFiancialProfile(): Promise<IApiResponse>;
  abstract activateCustomerPortfolio(): Promise<IApiResponse>;
  abstract completeCustomerPortfolio(): Promise<IApiResponse>;
  abstract activateApplicationReview(): Promise<IApiResponse>;
  abstract completeApplicationReview(): Promise<IApiResponse>;
  abstract activateMsa(): Promise<IApiResponse>;
  abstract completeMsa(): Promise<IApiResponse>;
  abstract activateNowAccountActivation(): Promise<IApiResponse>;
  abstract completeNowAccountActivation(): Promise<IApiResponse>;
  abstract activateClient(): Promise<IApiResponse>;
}
